/** All available mailing types - restrictions on the choice of mailing addressees */
export enum MailingTypeEnum {
  /** Send debt notices to debtors */
  DEBTORS = 'DEBTORS',
  /** Send debt notices to debtors from Excel file */
  DEBTORS_FROM_FILE = 'DEBTORS_FROM_FILE',
  /** Send bills to counterparties */
  BILLS = 'BILLS',
  /** Common mailings (notifications, sales etc.) */
  COMMON = 'COMMON',
  /** HelpDesk clients mailings */
  HELPDESK = 'HELPDESK',
  /** Send documents to counterparties */
  DOCUMENTS = 'DOCUMENTS',
}
